import { tns as TinySlider } from "~/node_modules/tiny-slider/src/tiny-slider"

class Sliders {

    init() {
        let sliders = document.querySelectorAll('.slider')
        sliders.forEach(item => {
            TinySlider({
                container: item,
                items: 1,
                loop: true,
                autoplay: true,
                autoplayTimeout: 4000,
                controls: false,
                nav: false,
                autoplayButtonOutput: false,
                mouseDrag: true
            });
        });

        let halfSliders = document.querySelectorAll('.slider--half')
        halfSliders.forEach(item => {
            TinySlider({
                container: item,
                items: 1,
                loop: true,
                autoplay: true,
                autoplayTimeout: 4000,
                controls: false,
                nav: false,
                autoplayButtonOutput: false,
                mouseDrag: true,

                responsive: {
                    700: {
                        items: 2
                    }
                }
            });
        });
    }
}

export default new Sliders();